"use client";
import { useState, useEffect } from "react";
import Home from "./Home";
import BotonMusica from "./BotonMusica";
import "./Hero.css";

export default function Hero() {
  const [mostrarHome, setMostrarHome] = useState(false);
  const [fadeOut, setFadeOut] = useState(false);
  const [imagenCargada, setImagenCargada] = useState(false);

  // Precargar imagen portada (por si quieres usar <img>)
  useEffect(() => {
    const img = new Image();
    img.src = "/portada.webp";
    img.onload = () => setImagenCargada(true);
    img.onerror = () => setImagenCargada(true);
  }, []);

  const handleIngresar = () => {
    setFadeOut(true);
    setTimeout(() => {
      if (imagenCargada) {
        setMostrarHome(true);
      } else {
        const esperar = setInterval(() => {
          if (imagenCargada) {
            clearInterval(esperar);
            setMostrarHome(true);
          }
        }, 200);
      }
    }, 1000);
  };

  return (
    <>
      {!mostrarHome && (
        <section className={`hero ${fadeOut ? "desaparece" : ""}`}>
          {/* Video de portada */}
          <video
            className="hero-video"
            autoPlay
            loop
            muted
            playsInline
            preload="auto"
          >
            <source src="/inicio.mp4" type="video/mp4" />
          </video>

          {/* Contenido */}
          <div className="hero-content">
            <h1>Martín & Juliana</h1>
            <p className="frase">Estás invitado a celebrar con nosotros</p>
            <button className="btn" onClick={handleIngresar}>
              Abrir invitación
            </button>
          </div>
        </section>
      )}

      {mostrarHome && (
        <div className="fade-in-home">
          <Home />
          <BotonMusica autoPlay />
        </div>
      )}
    </>
  );
}
